module.exports = __webpack_public_path__ + "img/starter.a392b689.svg";